<template>
	<div class="card" @click="toggle = !toggle">
		<div>
			<div class="image" :style="{paddingBottom: `${ratio * 100}%`}">
				<div class="background" :style="{backgroundImage: `url(${image})`}"></div>
			</div>

			<div class="title">{{ title }}</div>

			<div :class="{'toggle': toggle}" class="description">
				<slot></slot>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'cardshop',

	data() {

		return {
			toggle: true
		}
	},

	props: {
		title: {
			type: String,
			required: false
		},

		description: {
			type: String,
			required: false
		},
		
		image: {
			type: String,
			required: false
		},

		ratio: {
			type: Number,
			default: 0.56
		}
	}
}
</script>

<style lang="stylus" scoped>
.natale
	.toggle
		display block
.card
	cursor pointer

.image
	position relative

	padding-bottom 100%

	.background
		width 100%
		height 100%

		position absolute
		top 0
		left 0

		background-image url('https://www.searchpng.com/wp-content/uploads/2019/02/Men-Profile-Image-715x657.png')
		background-size cover
		background-position top

.title
	padding 0.4em 0.6em

	background-color primary
	color dark

	font-size 1.8em
	font-family fontMono

	text-align center
	text-transform uppercase

.toggle
	display none
	
.description
	padding 1em

	background-color dark

	font-family fontSans
	font-size 1.2em
	text-align justify

	p
		margin-top -1px

	span
		color red

	button

		font-size 1em
		border 1px solid black
		padding 0.5em
		margin-right 0.4em
		margin-top 0.4em
		cursor pointer
		background #ffe010
		text-transform uppercase
		font-weight bold
		color dark

	.prezzo
		font-weight bold
		font-size 1.4em
		text-align center

	.buy
		text-align center
	
	.center
		text-align center
</style>